module.exports = __webpack_public_path__ + "static/media/SladiPetrov.76e12085.png";